import { Lock, LockOpen } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/shadcn/tooltip'

// Per-node lock toggle shown in the selected-item menus. A locked layer stays
// selectable and editable but is excluded from marquee select and can't be dragged,
// resized, or rotated. Rendered inside each menu's existing TooltipProvider.
export function LockToggleButton({ locked, onToggle }: { locked: boolean; onToggle: () => void }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className="hover:bg-hover flex cursor-pointer items-center justify-center rounded-sm p-1"
          onClick={onToggle}>
          {locked ? (
            <Lock size={22} color="var(--foreground)" />
          ) : (
            <LockOpen size={22} color="var(--foreground)" />
          )}
        </span>
      </TooltipTrigger>
      <TooltipContent className="w-full">
        <p>{locked ? 'Unlock layer' : 'Lock layer'}</p>
      </TooltipContent>
    </Tooltip>
  )
}
